module.exports = "form {\n  padding: 20px;\n  background-color: white;\n}\n\nh3 {\n  margin: 20px;\n}\n\nbutton {\n  margin-top: 20px;\n}\n"